// extracted by mini-css-extract-plugin
export default {"player":"styles_player__dnv4Q","container":"styles_container__v5LCR","tutorial":"styles_tutorial__Ai5TL","play":"styles_play__Y-CM9"};